export default {
  constants: {
    VIDEO_MODE_INITIAL: 'initial',
    VIDEO_MODE_JOINING: 'joining',
    VIDEO_MODE_IN_MEETING: 'in_meeting',
  },
};
